import { useGetHasGate } from 'crm-object-board-core/user';
import { gate } from 'hub-http/gates';
import { useBoardCoreData } from '../providers/BoardCoreDataProvider';
const CARDV2_GATE = gate('CRM:Pipelines:CRMObjectBoardCard');
export const useHasCardV2Gate = forceCardV2 => {
  const {
    hasGate
  } = useGetHasGate();
  return forceCardV2 || hasGate(CARDV2_GATE);
};
export const useHasCardV2 = () => {
  const {
    forceCardV2
  } = useBoardCoreData();
  return useHasCardV2Gate(forceCardV2);
};